"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clipboard_events_1 = require("./clipboard-events");
function reduceClipboardAction(events, action) {
    if (events === void 0) { events = []; }
    switch (action.action) {
        case "COPY":
            return __spread(events, dispatchCopyEvents(action));
        case "PASTE":
            return __spread(events, dispatchPasteEvents(action));
    }
}
exports.reduceClipboardAction = reduceClipboardAction;
function validateSelectionForCopy(selection) {
    var anyCells = !!selection.enumerateCells().next().value;
    if (!anyCells) {
        return [{ message: "Selection is required to copy a cell pattern." }];
    }
    if (selection.addSelection) {
        if (!selection.isContiguous()) {
            return [{ message: "Cannot copy from multiple selections." }];
        }
    }
    return [];
}
exports.validateSelectionForCopy = validateSelectionForCopy;
function processPatternData(s) {
    var rows = s.split("\n");
    return rows.map(function (p) { return p.split("\t"); });
}
exports.processPatternData = processPatternData;
function serializePatternData(data) {
    return data.map(function (p) { return p.map(function (q) { return String(q).replace(/[\n\t]/g, " "); }).join("\t"); }).join("\n");
}
exports.serializePatternData = serializePatternData;
function dispatchCopyEvents(action) {
    var e_1, _a;
    var errorEvents = validateSelectionForCopy(action.selection);
    if (errorEvents.length) {
        return errorEvents.map(function (p) { return clipboard_events_1.createError(p.message); });
    }
    var pattern = [];
    var processedTDs = [];
    var _loop_1 = function (cell) {
        var td = action.grid[cell.i][cell.j];
        var row = pattern[cell.i] || (pattern[cell.i] = []);
        if (processedTDs.find(function (p) { return p === td; })) {
            row[cell.j] = "";
        }
        else {
            row[cell.j] = action.dataSelector(td) || "";
            processedTDs.push(td);
        }
    };
    try {
        for (var _b = __values(action.selection.enumerateCells()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var cell = _c.value;
            _loop_1(cell);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return [{
            event: "PATTERN_FILLED",
            pattern: pattern.map(function (p) { return p.filter(function (q) { return q !== undefined; }); })
                .filter(function (p) { return p.length; })
        }];
}
exports.dispatchCopyEvents = dispatchCopyEvents;
function dispatchPasteEvents(action) {
    var events = getChangedCellValues(action, action.selection);
    if (events.length === 0) {
        return [clipboard_events_1.createError("The paste operation could not be completed")];
    }
    var results = events.filter(function (p) { return p.event !== "CELL_VALUE_CHANGED"; });
    var changes = events.filter(function (p) { return p.event === "CELL_VALUE_CHANGED"; });
    if (!results.some(function (p) { return p.event === "ERROR"; }) && changes.length) {
        results.push({
            event: "SELECTION_FILLED",
            cellValueChanges: changes,
            grid: action.grid,
            pattern: action.pattern,
            selection: action.selection
        });
    }
    return results;
}
exports.dispatchPasteEvents = dispatchPasteEvents;
function getChangedCellValues(action, selection, parent) {
    var e_2, _a, e_3, _b;
    if (parent === void 0) { parent = null; }
    if (selection.addSelection) {
        parent = parent || selection;
        var composite = selection;
        var results = [];
        try {
            for (var _c = __values(composite.getAddedSelections()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var added = _d.value;
                results.push.apply(results, __spread(getChangedCellValues(action, added, parent)));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return results;
    }
    else if (selection.start) {
        if (parent) {
            try {
                for (var _e = __values(selection.enumerateCells()), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var cell = _f.value;
                    if (!parent.containsCell(cell)) {
                        return [];
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return getChangedRangeCellValues(action, selection);
    }
    else {
        return [clipboard_events_1.createError("Unsupported selection range.")];
    }
}
exports.getChangedCellValues = getChangedCellValues;
function getChangedRangeCellValues(action, selection) {
    var bounds = selection.getBounds();
    var height = bounds.max.i - bounds.min.i + 1;
    var width = bounds.max.j - bounds.min.j + 1;
    if (height < action.pattern.length) {
        if (height === 1) {
            height = action.pattern.length;
        }
        else {
            return [clipboard_events_1.createError("Paste selection is smaller than pattern in buffer")];
        }
    }
    if (width < action.pattern[0].length) {
        if (width === 1) {
            width = action.pattern[0].length;
        }
        else {
            return [clipboard_events_1.createError("Paste selection is smaller than pattern in buffer")];
        }
    }
    var res = [];
    for (var i = 0; i < height; i++) {
        if (bounds.min.i + i >= action.grid.length) {
            break;
        }
        var patternRow = action.pattern[i % action.pattern.length];
        var patternRepetitions = Math.max(1, Math.ceil(width / patternRow.length));
        var j = 0;
        while (j < patternRepetitions * patternRow.length
            && j < Math.min(bounds.min.j + width, action.grid[bounds.min.i + i].length)) {
            res.push({
                event: "CELL_VALUE_CHANGED",
                cell: action.grid[bounds.min.i + i][bounds.min.j + j],
                value: patternRow[j % patternRow.length]
            });
            j++;
        }
    }
    return res;
}
exports.getChangedRangeCellValues = getChangedRangeCellValues;
